import React from "react";
import {
  CircularProgress,
  Typography,
  IconButton,
  Link,
} from "@material-ui/core";
import "./UploadedFileField.css";

export type UploadStatus = "none" | "uploading" | "uploaded" | "failed";

interface IUploadedFileFieldProps {
  uploadStatus: UploadStatus;
  source: string;
  title?: string | null;
  downloadLink?: string | null;
  record?: any;
}

export const UploadedFileField = (props: IUploadedFileFieldProps) => {
  const { uploadStatus, downloadLink, title } = props;
  switch (uploadStatus) {
    case "none":
      return null;
    case "failed":
      return (
        <>
          <div className="uploading-file-wrapper" style={{ marginLeft: "5px" }}>
            <Typography variant="body2">
              Upload failed. Please try again.
            </Typography>
          </div>
        </>
      );
    case "uploading":
      return (
        <>
          <style>{`.file-input .previews > div > button { display: none; }`}</style>
          <div className="uploading-file-wrapper">
            <IconButton disabled>
              <CircularProgress size="1em" />
            </IconButton>
            <Typography variant="body2">
              Uploading file, please wait...
            </Typography>
          </div>
        </>
      );
    case "uploaded":
      return (
        <Link
          href={downloadLink ?? props.record.src}
          style={{ marginLeft: "5px" }}
        >
          {title ?? props.record.rawFile.name}
        </Link>
      );
  }
};
